<div class="agpr-formField agpr-imageEffectsField">
    <!-- Image Frame -->
    <div class="agpr-imageEffectsField-frame">
        <div class="agpr-imageEffectsField-frameTitle">
            <span>
                {{ 'Briefings.fields.image.frame' | localize }}
            </span>
        </div>

        <div class="agpr-imageEffectsField-frameImages">
            @for (frame of imageFrames; track frame.key) {
                <div
                    class="agpr-imageEffectsField-frame-container"
                    [ngClass]="{'agpr-imageEffectsField-frame-container-selected' : frame.key === value.imageFrame}"
                    (click)="setFrame(frame.key)"
                >
                    <div
                        class="agpr-imageEffectsField-frame-container-image"
                        [ngClass]="{'agpr-imageEffectsField-frame-container-image-noPadding' : frame.img}"
                    >
                        @if (frame.img) {
                            <img
                                [src]="appBaseHref + frame.img"
                            >
                        }
                    </div>
                    <div class="agpr-imageEffectsField-frame-container-label">
                        {{frame.label | localize}}
                    </div>
                </div>
            }
        </div>
    </div>


    <!-- Frame Colors -->
    <div class="agpr-imageEffectsField-frameTitle">
        <span>
            {{ 'Briefings.fields.image.frameColor' | localize }}
        </span>
    </div>
    <div class="agpr-imageEffectsField-frameColor">
        <agpr-color-picker-field
            [id]="id + '_accentColorPicker'"
            [field]="primColorPickerField"
            [value]="value.primaryColor"
            (changes)="valueChange($event, 'primaryColor')"
        ></agpr-color-picker-field>

    </div>

    <!--
        TODO: not being used right now but keep for possible future frames / templates
        <agpr-color-picker-field
            [id]="id + '_backgroundColorPicker'"
            [value]="value.backgroundColor"
            [field]="backColorPickerField"
            [ignoreDefaultValue]="true"
            tooltip="Briefings.fields.image.background.tooltip"
            (changes)="valueChange($event, 'backgroundColor')"
        ></agpr-color-picker-field>
    -->




    <!-- Image Transiton -->
    <div class="agpr-imageEffectsField-frameTitle">
        <span>
            {{ 'Briefings.fields.image.imageTransitions' | localize }}

            <span
                role="img"
                class="fa-regular fa-circle-info"
                agprTooltip="Briefings.fields.image.imageTransitions.tooltip"
            ></span>
        </span>
    </div>
    <div [tooltipPosition]="'top'"
        [agprTooltip]="(value.imageFrame !== briefingImageFrame.NO_FRAME) ? 'Briefings.fields.image.imageTransitions.notCorrectFrame' :
            (imageDisplayElement?.images?.length <= 1) ? 'Briefings.fields.image.imageTransitions.multipleImages' : ''"
    >
        <div
            class="agpr-imageEffectsField-transitionCheckbox"
        >
            <agpr-checkbox
                [disabled]="(value.imageFrame !== briefingImageFrame.NO_FRAME) || (imageDisplayElement?.images?.length <= 1)"
                [binary]="true"
                [(ngModel)]="enableTransition"
                [label]="'Briefings.fields.image.enableTransition'"
                (ngModelChange)="enableTransitionChanged()"
            >
            </agpr-checkbox>
        </div>

        @if (enableTransition) {
            <div class="agpr-imageEffectsField-transition">
                <agpr-number-input
                    [disabled]="(value.imageFrame !== briefingImageFrame.NO_FRAME) || (imageDisplayElement?.images?.length <= 1)"
                    class="agpr-briefingChartDimensionsField-height"
                    [id]="id + '_transitionTime'"
                    label="Briefings.fields.image.transitionTime"
                    [min]="1"
                    [max]="10"
                    [integerOnly]="true"
                    ariaLabelledBy="chart_height_label"
                    [(ngModel)]="value.transition"
                    (ngModelChange)="valueChange($event, 'transition')"
                ></agpr-number-input>
            </div>
        }
    </div>
</div>
